import React, { useEffect, useRef, useState } from "react";
import classes from "../../../css/components/WordPressArchiveList.module.css";
import { Wrapper } from "./Wrapper";
import { wordpressCategoryIds, wordpressCategoryTitles } from "../../../pages/constants/wordpress";
import { getWordpressPostList } from "../../../pages/utils/wordpress";
import { Link, useParams } from "react-router-dom";
import { getLinkWithGclid } from "../../../history";

function WordPressArchiveList() {
  const { slug } = useParams<any>();
  const [list, setList] = useState<Array<any>>([]);
  const categoryCode = wordpressCategoryIds[slug]; // TBD : Change to 'policy'
  const categoryTitle = wordpressCategoryTitles[slug] + " Archives"; // TBD : Change to 'policy'
  const subscribed = useRef(false);

  const getPost = async () => {
    await getWordpressPostList(categoryCode?.toString(), setList, subscribed);
  };

  useEffect(() => {
    if (!categoryCode) return;
    subscribed.current = true;
    getPost();
    return () => {
      subscribed.current = false;
    };
  }, [categoryCode]);

  const sorted = list?.sort((a, b) => {
    const adate = a?.title?.rendered?.split("&#8211;")[1];
    const bdate = b?.title?.rendered?.split("&#8211;")[1];

    if (!adate) return -1;
    if (!bdate) return 1;

    if (new Date(bdate).getTime() > new Date(adate).getTime()) {
      return -1;
    } else {
      return 1;
    }
  });

  return (
    <Wrapper title={categoryTitle}>
      <div className={classes.root}>
        <p className={classes.description}>
          We want to be as transparent as possible about the changes we make to our {categoryTitle}. In this archive you can see the previous versions
          of the policy.
        </p>
        <ul>
          {sorted?.map((post: any, index: number) => (
            <li className={classes.link} key={post.id}>
              <Link to={getLinkWithGclid(index === 0 ? `/${slug}` : `/${slug}/archive/${post.slug ?? ""}`)}>
                {post?.title.rendered?.split("&#8211;")?.join(" - ") + (index === 0 ? " (Current)" : "")}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </Wrapper>
  );
}

export default WordPressArchiveList;
